export const invTargetList = [
    {
        description: 'invTargetList.shortTerm',
        label: 'invTargetList.shortTerm',
        type: 'invTargetList',
        value: '1'
    },
    {
        description: 'invTargetList.hedging',
        label: 'invTargetList.hedging',
        type: 'invTargetList',
        value: '2'
    },
    {
        description: 'invTargetList.longTerm',
        label: 'invTargetList.longTerm',
        type: 'invTargetList',
        value: '3'
    },
    {
        description: 'invTargetList.diversified',
        label: 'invTargetList.diversified',
        type: 'invTargetList',
        value: '4'
    }
];

export default invTargetList;